// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2nNPc","question":"Question_question__yzsRh","description":"Question_description__2BEOO"};